import { ClassNames } from '@emotion/react';
import React, { useRef } from 'react';

export function Icon(props) {
  //Extract the icon that was passed
  let { icon, fw, innerRef, className, ...rest } = props;
  const iconRef = innerRef ? innerRef : useRef();
  //Encapsulate in an array if not already
  if (!Array.isArray(icon)) {
    icon = [icon];
  }

  icon.push('chronos-icon');

  //Check if the icon has fixedwidth defined
  if (fw) {
    for (let iconClass of icon) {
      if (iconClass.toLowerCase().indexOf('fa') === 0) {
        icon.push('fa-fw');
        break;
      }
      if (iconClass.toLowerCase().indexOf('ra') === 0) {
        icon.push('ra-fw');
        break;
      }
    }
    icon.push('chronos-icon-fixed-width');
  }
  if (className !== undefined && className.length > 0) {
    icon.push(className);
  }
  let iconClasses = icon.join(' ');

  return <i className={iconClasses} ref={iconRef} {...rest}></i>;
}
